<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :title="title"
    width="1000px"
    custom-class="main-content"
    @close="cancel(0)"
  >
    <div class="tabs-container">
      <el-tabs :active-name="activeLable" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_ViewPaymentRequest')" name="applicationForm">
          <application-form
            ref="applicationForm"
            :open-sap-config="openSapConfig"
            :bill-payment-uuid="billPaymentUuid"
            :params-final="state"
            :params-charges="charges"
            :charges-dirty="chargesDirty"
            :bill-payment-dirty="billPaymentDirty"
            :parent-context="parentContext"
            :location="location"
            style="width: 100%;"
            @cancel="cancel($event)"
            @toPreStep="toPreStep"
          />
        </el-tab-pane>
        <!--<el-tab-pane v-if="state!=-1 && openSapConfig==true" :label="$t('CargoMsg.Cargo_FileHistory')" :lazy="true" name="fileHistory">-->
        <el-tab-pane v-if="state!=-1" :label="$t('CargoMsg.Cargo_FileHistory')" :lazy="true" name="fileHistory">
          <file-history
            :bill-payment-uuid="billPaymentUuid"
            :bill-payment-state="fileState"
            :input-by="inputBy"
            :upload-enable="viewSource == 'tabBilling'"
            @reloadData="reloadData($event)"
          />
        </el-tab-pane>
        <el-tab-pane v-if="state!=-1" :label="$t('CargoMsg.Cargo_ApprovalHistory')" :lazy="true" name="approvalList">
          <approval-history :bill-payment-uuid="billPaymentUuid" style="width: 100%;" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>

import applicationForm from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/applicationForm'
import approvalHistory from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/approvalHistory'
import fileHistory from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/fileHistory'

export default {
  name: 'BillPaymentDetail',
  components: {
    applicationForm, // 申请单
    approvalHistory, //  审批历史
    fileHistory // 文件历史
  },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    billPaymentUuid: { type: String, required: false },
    state: { type: Number, required: true },
    openSapConfig: { type: Boolean, required: true },
    charges: { type: Array, required: false },
    chargesDirty: { type: Boolean, required: true }, // 费用更新否
    billPaymentDirty: { type: Boolean, required: true }, // 付款申请更新否
    inputBy: { type: Number, required: true }, // 付款申请更新否
    parentContext: { type: Object, required: true },
    viewSource: { type: String, default: null }, // 请求来源
    location: { type: String, required: false }
  },
  data() {
    return {
      // 当前展示激活业签名
      activeLable: 'applicationForm',
      // 文件历史中 付款申请状态
      fileState: this.state,
      // 是否可见 文件，和审批历史
      canShow: true
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    billPaymentUuid(newVal) {
      if (this.viewSource === 'tabBilling' && newVal) {
        this.$nextTick(() => {
          this.$refs.applicationForm.loadData()
          this.fileState = this.state
        })
      }
    }
  },
  methods: {
    cancel(data) {
      if (!this.viewSource) {
        if (data.from === 0) {
          this.$emit('update:visible', false)
        } else if (data.from === 1) { // 1更新刷列表一条数据 关闭本身
          this.$emit('reflushRowData', this.billPaymentUuid)
          this.$emit('update:visible', false)
        } else if (data.from === 2) { // 2新增刷列表，关闭本身
          this.$emit('reflushRowData', undefined)
          this.$emit('update:visible', false)
        } else { // 3提交后刷列表数据，不关闭本身
          this.$emit('reflushRowData', undefined)
          this.fileState = 1
        }
      } else {
        if (data.from !== 0) {
          this.$emit('refreshBillPayment', data.billPayment)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    // tab 页签点击事件
    handleClick(tab, event) {
      console.log(tab, event)
      this.activeLable = tab.name
    },
    // 触发基本页签load数据
    reloadData() {
      this.$refs.applicationForm.loadData()
      if (!this.viewSource) {
        this.$emit('reflushRowData', this.billPaymentUuid)
      }
    },
    // 触发列表刷新数据
    reflushListRowData() {
      this.$emit('reflushRowData', this.billPaymentUuid)
    },
    // 上一步
    toPreStep() {
      this.$emit('toPreStep')
    }
  }
}
</script>

<style lang="scss">
</style>
